(()=>{'use strict';
let rankingPromise;
function loadRanking(){
  if(rankingPromise)return rankingPromise;
  rankingPromise=(async()=>{
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),8000);
    try{
      const root=(document.body.dataset.root||'/').replace(/\/?$/, '/');
      const url=new URL(root+'collections/all',location.origin);
      url.searchParams.set('sort_by','best-selling');
      url.searchParams.set('section_id','mg-bestseller-data');
      const response=await fetch(url,{signal:controller.signal});
      if(!response.ok)throw Error('Ranking unavailable');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const payload=JSON.parse(html.querySelector('[data-mg-bestseller-ranking]')?.textContent||'null');
      if(!payload||payload.limit!==20||!Array.isArray(payload.ids)||payload.ids.length>20)throw Error('Invalid ranking');
      return new Set(payload.ids.map(String));
    }catch{return new Set();}finally{clearTimeout(timeout);}
  })();
  return rankingPromise;
}
async function syncBadges(){
  if(!document.querySelector('[data-badge-product-id]'))return;
  const ids=await loadRanking();
  document.querySelectorAll('[data-badge-product-id]').forEach(group=>{
    const badge=group.querySelector('[data-badge="best-seller"]');
    if(!badge)return;
    badge.hidden=!ids.has(group.dataset.badgeProductId);
    group.hidden=!group.querySelector('[data-badge]:not([hidden])');
  });
}
syncBadges();
document.addEventListener('shopify:section:load',syncBadges);
const main=document.querySelector('main');
if(main)new MutationObserver(changes=>{if(changes.some(change=>change.addedNodes.length))syncBadges();}).observe(main,{childList:true,subtree:true});
})();
